import React from 'react'

import { cn } from '@amusnet/react-ui'

interface StrokedGradientTextProps {
    children: string
    /* Shared sizing/transform class applied to both layers so they overlap exactly. */
    textClassName?: string
    /* Gradient (background-clip:text) class for the visible top layer. */
    gradientClassName: string
}

/**
 * Gradient text with a crisp outline.
 *
 * The stroke lives on a plain-black copy rendered behind the gradient copy, because
 * `-webkit-text-stroke` on `background-clip:text` renders broken in Safari (clipped / bordered
 * glyphs). Keeping the stroke off the clipped element sidesteps that bug: every browser strokes
 * solid-black text cleanly, and the gradient copy on top leaves only the ~1px outline showing.
 * Both layers share `textClassName` so they overlap pixel-for-pixel.
 */
export const StrokedGradientText: React.FC<StrokedGradientTextProps> = ({
    children,
    textClassName,
    gradientClassName,
}) => (
    <div className="relative inline-block">
        <div
            aria-hidden="true"
            className={cn(
                textClassName,
                '[color:#000] [-webkit-text-stroke:2px_#000] [filter:drop-shadow(0px_2px_0px_rgba(0,0,0,0.25))]'
            )}
        >
            {children}
        </div>
        <div className={cn(textClassName, gradientClassName, 'absolute left-0 top-0')}>{children}</div>
    </div>
)
